import styled from 'styled-components';
import { Row } from 'components/layout';
import { color, typography } from 'styles/settings';
import { ReactComponent as Copy } from 'styles/icons/copy-to-clipboard.svg';
import { normalize } from 'utils/styles';

export const AdminLayout = styled.div`
  background-color: white;
  padding: 40px;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
`;

export const Footer = styled(Row)`
  display: flex;
  fled-direction: row;
  width: 20%;
  margin-top: ${typography.size.md};
  justify-content: space-between;
`;

export const CopyIcon = styled(Copy)`
  color: ${color.brand.gold};
  cursor: pointer;
  height: ${normalize('16px')};
  width: ${normalize('16px')};
`;

export const ListView = styled.div``;

export const TableContainer = styled.div`
  width: 70%;
  margin: auto;
  height: 80vh;
  @media all and (max-width: 1200px) {
    width: 90%;
  }
`;

export const TableContainerNoScroll = styled.div`
  width: 70%;
  margin: auto;
  overflow-y: scroll;
  height: 80vh;
  @media all and (max-width: 1200px) {
    width: 90%;
  }
`;
